import { addMessages } from '@hana/i18n';

// Khoá chuỗi của drawer Lập hoá đơn (InvDrawer.tsx). Mã phí, số B/L, tên riêng không dịch.
addMessages('vi', {
  'dr.title': 'Lập hoá đơn',
  'dr.fromDebit': 'Từ debit {dn} · khách đã xác nhận',
  'dr.buyerAria': 'Người mua',
  'dr.buyer': 'Người mua · theo bill_to của dòng phí',
  'dr.mst': 'Mã số thuế *',
  'dr.looked': 'Đã tra MST {mst} · tự điền tên và địa chỉ',
  'dr.lookup': 'Tra MST',
  'dr.mstOk': 'Đang hoạt động · tra từ cổng thuế 22/Oct/2026 08:10',
  'dr.mstHint': 'Bấm "Tra MST" để tự điền tên, địa chỉ',
  'dr.name': 'Tên đơn vị',
  'dr.addr': 'Địa chỉ',
  'dr.addrPh': 'Tra MST hoặc nhập địa chỉ xuất hoá đơn',
  'dr.addrMiss': 'Thiếu địa chỉ',
  'dr.email': 'Email nhận HĐ',
  'dr.emailBad': 'Email chưa đạt',
  'dr.pay': 'Hình thức thanh toán',
  'dr.payTf': 'Chuyển khoản',
  'dr.linesAria': 'Dòng phí',
  'dr.lines': 'Dòng phí · job {job}',
  'dr.vatNote': 'VAT theo mã phí · không sửa tay',
  'dr.thCode': 'Mã phí',
  'dr.thDesc': 'Diễn giải',
  'dr.thQty': 'SL',
  'dr.thPrice': 'Đơn giá',
  'dr.thAmt': 'Thành tiền ₫',
  'dr.vatTitle': 'Thuế suất theo mã phí {code} (charge_tax_rule) · không sửa tay',
  'dr.of0': 'O/F 0% áp cho cước vận tải quốc tế — căn cứ: B/L YMLUI 450 218 773 đã đính kèm. Không có căn cứ thì dòng này không phát hành được.',
  'dr.chiHo': 'Chi hộ · chứng từ riêng, không VAT, không tính doanh thu',
  'dr.chiHoRow': 'Phí CSHT cảng biển (chi hộ, kèm biên lai)',
  'dr.fxAria': 'Tỷ giá',
  'dr.fx': 'Tỷ giá Job',
  'dr.fxDown': 'Giảm tỷ giá',
  'dr.fxUp': 'Tăng tỷ giá',
  'dr.fxLow': 'Hạ dưới tỷ giá Job 25.400 → cần [ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP duyệt trước khi phát hành',
  'dr.fxNote': 'Tỷ giá Job theo ETD 22/Oct (VCB bán) · chỉ được sửa tăng',
  'dr.issueAria': 'Phát hành',
  'dr.preCheck': 'Kiểm trước phát hành',
  'dr.missing': 'Chưa phát hành được — còn thiếu: {list}.',
  'dr.sign': 'Ký số bằng MISA eSign ngay khi phát hành',
  'dr.mail': 'Gửi khách qua email + link xem trên myHANA',
  'dr.total': 'Tổng thanh toán',
  'dr.cancel': 'Huỷ',
  'dr.noWrite': 'Chưa mở ghi ở bản này',
  'dr.draft': 'Lưu nháp',
  'dr.missN': 'Còn {n} mục kiểm chưa đạt',
  'dr.sendKtt': 'Gửi KTT duyệt tỷ giá',
  'dr.issueSign': 'Phát hành & ký số',
});
addMessages('en', {
  'dr.title': 'Create invoice',
  'dr.fromDebit': 'From debit {dn} · confirmed by customer',
  'dr.buyerAria': 'Buyer',
  'dr.buyer': 'Buyer · per bill_to of the charge line',
  'dr.mst': 'Tax code *',
  'dr.looked': 'Tax code {mst} looked up · name and address filled in',
  'dr.lookup': 'Look up tax code',
  'dr.mstOk': 'Active · looked up from tax portal 22/Oct/2026 08:10',
  'dr.mstHint': 'Press "Look up tax code" to fill in name and address',
  'dr.name': 'Company name',
  'dr.addr': 'Address',
  'dr.addrPh': 'Look up the tax code or enter the invoice address',
  'dr.addrMiss': 'Address missing',
  'dr.email': 'Invoice email',
  'dr.emailBad': 'Email invalid',
  'dr.pay': 'Payment method',
  'dr.payTf': 'Bank transfer',
  'dr.linesAria': 'Charge lines',
  'dr.lines': 'Charge lines · job {job}',
  'dr.vatNote': 'VAT by charge code · not editable',
  'dr.thCode': 'Charge code',
  'dr.thDesc': 'Description',
  'dr.thQty': 'Qty',
  'dr.thPrice': 'Unit price',
  'dr.thAmt': 'Amount ₫',
  'dr.vatTitle': 'Tax rate by charge code {code} (charge_tax_rule) · not editable',
  'dr.of0': 'O/F 0% applies to international freight — basis: B/L YMLUI 450 218 773 attached. Without a basis this line cannot be issued.',
  'dr.chiHo': 'Disbursements · separate document, no VAT, not counted as revenue',
  'dr.chiHoRow': 'Port infrastructure fee (disbursement, with receipt)',
  'dr.fxAria': 'Exchange rate',
  'dr.fx': 'Job exchange rate',
  'dr.fxDown': 'Decrease rate',
  'dr.fxUp': 'Increase rate',
  'dr.fxLow': 'Below Job rate 25.400 → needs [ACC-CA · Chief Accountant] (seat vacant) · escalates to BOD-DIR PHILIP for approval before issuing',
  'dr.fxNote': 'Job rate per ETD 22/Oct (VCB sell) · can only be raised',
  'dr.issueAria': 'Issue',
  'dr.preCheck': 'Pre-issue checks',
  'dr.missing': 'Cannot issue yet — missing: {list}.',
  'dr.sign': 'Sign with MISA eSign on issue',
  'dr.mail': 'Send to customer by email + myHANA view link',
  'dr.total': 'Total payable',
  'dr.cancel': 'Cancel',
  'dr.noWrite': 'Writing is not enabled in this version',
  'dr.draft': 'Save draft',
  'dr.missN': '{n} checks not passed',
  'dr.sendKtt': 'Send to Chief Accountant for rate approval',
  'dr.issueSign': 'Issue & sign',
});
